import { render, staticRenderFns } from "./ChuyenTrangThaiXuLyPhanHoiAdmin.vue?vue&type=template&id=2faa4362&"
import script from "./ChuyenTrangThaiXuLyPhanHoiAdmin.vue?vue&type=script&lang=js&"
export * from "./ChuyenTrangThaiXuLyPhanHoiAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports